/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-08 15:58:32                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-11-12 15:48:49                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Styles
  * OtherAction: dashboard other actions section
*/

/* Imports */
import { Card, Typography } from "@material-tailwind/react";
import ActionItem from "./ActionItem";
import { BriefcaseIcon, CalculatorIcon, CalendarIcon, UsersIcon } from "@heroicons/react/24/outline";
/***/

/* Styles */
import "./OtherActions.scss";
import { t } from "../../../../i18n";
/***/

/**
* OtherAction: dashboard other actions section
* display link to app actions not displayed in cards 
*/
export default function OtherAction() {
  const actions = [{
    name: t("common:customers"),
    icon: <UsersIcon color="#0369A1"/>,
    color: "#F0F9FF",
    path: "/customers"
  }, {
    name: t("common:calendar"),
    icon: <CalendarIcon color="#B45309"/>,
    color: "#FFFBEB",
    path: "/planning"
  }, {
    name: t("common:quotations"),
    icon: <CalculatorIcon color="#de234f"/>,
    color: "#fff2f5",
    path: "/quotations"
  }, {
    name: t("common:visits"),
    icon: <BriefcaseIcon color="#00b000"/>,
    color: "#f0fff0",
    path: "/visits"
  }];

  return(
    <div className="other-action">
      <Typography className="mb-2 text-xl text-blue-700 font-medium">
        {t("common:otherActions")}
      </Typography>

      <Card className="shadow-none border border-gray-300 grid grid-cols-2 overflow-hidden">
        {actions.map((action, i) => <ActionItem key={`action-${i}`} data={action}/>)}
      </Card>
    </div>
  );
}
/***/
